import { Card } from "@/shared/ui/card";

export function PropertiesSkeleton() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <div className="glass-panel mb-4 flex-shrink-0 rounded-2xl p-6">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 animate-pulse rounded-xl bg-muted" />
            <div className="space-y-2">
              <div className="h-6 w-52 animate-pulse rounded bg-muted" />
              <div className="h-4 w-80 animate-pulse rounded bg-muted" />
            </div>
          </div>
          <div className="flex gap-3">
            <div className="h-9 w-24 animate-pulse rounded bg-muted" />
            <div className="h-9 w-28 animate-pulse rounded bg-muted" />
          </div>
        </div>
        <div className="h-12 w-full animate-pulse rounded bg-muted" />
      </div>

      <div className="flex-1 overflow-hidden px-2 py-1">
        <div className="space-y-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-[82px] animate-pulse rounded-lg bg-muted" />
          ))}
        </div>
      </div>

      <div className="flex-shrink-0 pt-4">
        <Card className="glass-effect border-border/50 p-3">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div className="h-5 w-40 animate-pulse rounded bg-muted" />
            <div className="flex items-center justify-end gap-3 md:min-w-[420px]">
              <div className="h-8 w-28 animate-pulse rounded bg-muted" />
              <div className="hidden items-center gap-2 md:flex">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="h-8 w-8 animate-pulse rounded bg-muted" />
                ))}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
